// extracted by mini-css-extract-plugin
module.exports = {"leaseDetailsSection":"LeaseDetailsSection_leaseDetailsSection__35DmA","detailItemList":"LeaseDetailsSection_detailItemList__2bU8P"};